import { useMemo } from 'react';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import SponsoredAdsProduct from 'components/search/SponsoredAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';
import MelodyCarousel from 'components/common/MelodyCarousel';

import css from 'styles/components/productdetail/sponsoredAdsCarousel.scss';

const RECOS_TITLE = 'Discover More Items';

const SponsoredAdsCarousel = ({
  CardBottomSlot = null,
  isFullMaxWidth,
  containerClassName,
  makeSponsoredAdClick,
  sponsoredAds = {},
  trackSponsoredAdImpressions
}) => {
  const {
    marketplace: {
      search: { hasStyleRoomFlag, msaMelodyImageParams, hasSponsoredAds }
    }
  } = useMartyContext();

  const products = useMemo(
    () =>
      sponsoredAds.results?.map(product => ({
        ...product,
        isSponsored: true
      })),
    [sponsoredAds.results]
  );

  if (!products || !hasSponsoredAds || products.length === 0) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div
        className={cn(css.recoCarousel, {
          [css.fullMaxWidth]: isFullMaxWidth
        })}
      >
        <h2>{RECOS_TITLE}</h2>
        <MelodyCarousel showDots={false} isFullMaxWidth={isFullMaxWidth}>
          {products.map((product, i) => {
            const { styleId, colorId } = product;
            product.isLowStock = getLowStockLabelStatus({
              ...product,
              hasStyleRoomFlag
            });
            return (
              styleId &&
              colorId && (
                <SponsoredAdsProduct
                  key={`${styleId}-${colorId}`}
                  product={{ ...product, index: i }}
                  numSponsoredAds={products.length}
                  isInCarousel={true}
                  trackSponsoredAdImpressions={trackSponsoredAdImpressions}
                  makeSponsoredAdClick={makeSponsoredAdClick}
                  msaImageParams={msaMelodyImageParams}
                  CardBottomSlot={CardBottomSlot}
                  isFullMaxWidth={isFullMaxWidth}
                />
              )
            );
          })}
        </MelodyCarousel>
      </div>
    </div>
  );
};

export default SponsoredAdsCarousel;
